import Loading from '@cartwhl/ui/atoms/Loading';

/**
 * Spinner chip matching batch thumbnail loading (white tile, no ring).
 * `corner` — absolute bottom-right on a relative thumb; `inline` — header / inline row.
 */
export default function BatchMotionThumbnailLoadingChip({
  compact,
  layout = 'corner',
  spinnerTone = 'default',
}: {
  compact?: boolean;
  layout?: 'corner' | 'inline';
  /** Green spinner for preview tiles; default gray matches processing thumbnails. */
  spinnerTone?: 'default' | 'green';
}) {
  const pad = spinnerTone === 'green' ? 'p-2' : compact ? 'p-1' : 'p-1.5';
  const shell =
    layout === 'corner'
      ? `pointer-events-none absolute right-2 bottom-2 z-10 flex items-center justify-center rounded-lg bg-white ${pad}`
      : `inline-flex shrink-0 items-center justify-center rounded-lg bg-white ${pad}`;

  const loadingClass =
    spinnerTone === 'green'
      ? 'text-green h-8 w-8'
      : compact
        ? 'text-gray-90 h-3 w-3'
        : 'text-gray-90 h-4 w-4';

  return (
    <div className={shell} aria-hidden>
      <Loading
        className={loadingClass}
        strokeWidth={compact && spinnerTone !== 'green' ? 3 : 4}
      />
    </div>
  );
}
